import { TComment } from "../model/types/types";

export const getUserFullName = (author: TComment["author"]) => {
  return `${author.firstName} ${author.lastName}`;
};

export const getUserInitials = (author: TComment["author"]) => {
  return `${author.firstName.charAt(0)}${author.lastName.charAt(0)}`.toUpperCase();
};

export const getMarkedText = (commentId: string) => {
  const mark = document.querySelector(`[data-persistent-comment-id="${commentId}"]`);
  return mark?.textContent || "";
};

export const removeMark = (commentId: string) => {
  const mark = document.querySelector(`[data-persistent-comment-id="${commentId}"]`);
  if (mark) {
    // Remove the mark's attributes but keep the text content
    const textContent = mark.textContent || "";
    const textNode = document.createTextNode(textContent);
    mark.parentNode?.replaceChild(textNode, mark);
  }
};
